import getAuthHeader from "../../../utils/getAuthHeader";
// odobri first formu

const getProjectInfosAndDepartments = async () => {
  try {
    const response = await fetch("/api/projectInfo", {
      headers: getAuthHeader(),
    });

    if (response.status === 403 || response.status === 401) {
      return {
        data: null,
        error: "UNAUTHORIZED",
      };
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const projectInfos = await response.json();

    const resDepartments = await fetch("/api/department");
    if (!resDepartments.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const departmentsData = await resDepartments.json();

    const formattedDepartments = departmentsData.map((department) => {
      return {
        id: department.id,
        fullName: `${department?.name} - ${department?.headName}`,
      };
    });

    return { data: { projectInfos, formattedDepartments }, error: null };
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
};

const approveFirstFormSubmit = async (projectId, username) => {
  try {
    const response = await fetch(
      `/api/projectInfo/approveFirstFormSubmit/${projectId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify({ username }),
      }
    );
    await response.json();
    if (response.ok) {
      return true;
    } else {
      const errorData = await response.json().catch(() => null);

      const errorMessage = errorData
        ? errorData.error
        : `Error: ${response.status} ${response.statusText}`;

      console.error("state='firstFormApproved' ERROR\nmessage:", errorMessage);
      return false;
    }
  } catch (error) {
    console.error("Error approving first form submit:", error);
    return false;
  }
};

// odobri second formu
const approveSecondFormSubmit = async (selectedProject, username) => {
  try {
    const response = await fetch(
      `/api/projectInfo/approveSecondFormSubmit/${selectedProject.id}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify({ ...selectedProject, username }),
      }
    );

    await response.json();

    if (response.ok) {
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      return true;
    } else {
      const errorData = await response.json().catch(() => null);

      const errorMessage = errorData
        ? errorData.error
        : `Error: ${response.status} ${response.statusText}`;

      console.error("state='secondFormApproved' ERROR\nmessage:", errorMessage);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      return false;
    }
  } catch (error) {
    console.error("Error approving second form submit:", error);
    return false;
  }
};

// firstFormSubmitted
const submitFirstForm = async (projectId) => {
  try {
    const response = await fetch(
      `/api/projectInfo/submitFirstForm/${projectId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
      }
    );

    // Parse the JSON response
    await response.json();

    if (response.ok) {
      window.alert("Podaci za namjeru uspješno poslani!");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      const errorData = await response.json().catch(() => null);

      const errorMessage = errorData
        ? errorData.error
        : `Error: ${response.status} ${response.statusText}`;

      window.alert("Greška u slanju podataka za namjeru: ", errorMessage);
    }
  } catch (error) {
    window.alert("Greška u slanju podataka za namjeru: ", error.message);
  }
};

const submitSecondForm = async (projectId) => {
  try {
    const response = await fetch(
      `/api/projectInfo/submitSecondForm/${projectId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
      }
    );

    await response.json();

    if (response.ok) {
      window.alert("Podaci za suglasnost uspješno poslani!");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      const errorData = await response.json().catch(() => null);

      const errorMessage = errorData
        ? errorData.error
        : `Error: ${response.status} ${response.statusText}`;

      window.alert("Greška u slanju podataka za suglasnost: ", errorMessage);
    }
  } catch (error) {
    window.alert("Greška u slanju podataka za suglasnost: ", error.message);
  }
};

const rejectProject = async (projectId, username) => {
  try {
    const response = await fetch(
      `/api/projectInfo/rejectProject/${projectId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeader(),
        },
        body: JSON.stringify({
          username,
        }),
      }
    );
    await response.json();
    if (response.ok) {
      return true;
    }
  } catch (error) {
    window.alert(
      "Unable to decline project, an error occurred: ",
      error.message
    );
    return false;
  }
};

// delete project
const deleteProject = async (project_id) => {
  try {
    const response = await fetch(`/api/projectInfo/${project_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    });

    const data = await response.json();

    if (response.ok) {
      window.alert("Projekt uspješno obrisan:", data);
    } else {
      window.alert("Greška u brisanju projekta: ", data.error);
    }
  } catch (error) {
    window.alert("Greška u brisanju projekta: ", error.message);
  }
};

const adminUpdateProjectInfoSet = async (
  projectId,
  fieldsToUpdate,
  username
) => {
  try {
    const response = await fetch(`/api/projectInfo/adminUpdate/${projectId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify({ ...fieldsToUpdate, username }),
    });
    await response.json();
    if (response.ok) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export {
  adminUpdateProjectInfoSet,
  approveFirstFormSubmit,
  approveSecondFormSubmit,
  deleteProject,
  getProjectInfosAndDepartments,
  rejectProject,
  submitFirstForm,
  submitSecondForm,
};
